import { InactiveAdminDeletedTemplateData } from '../inactive-admin-deleted/inactive-admin-deleted.component';

export const InactiveCompanyDeletedTemplateMocks: InactiveAdminDeletedTemplateData[] = [
  {
    title: 'Your company account [Company_name_here] has been deleted',
    p1: 'We deleted your company account because your subscription has been inactive for over 6 months. If you want to keep using Recruitee, please create a new account.',
    button_text: 'See plans',
    button_link: 'http://recruitee.com',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
